'use client';

import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import dynamic from 'next/dynamic';
import { Plus, ArrowRight } from 'lucide-react';

// Fetched on the first tap, not with the home page.
const AddListingPromoModal = dynamic(() => import('./AddListingPromoModal'), { ssr: false });

// On the rentals home page the promotion is for landlords (2026-09-28).
export default function AddListingPromo({ lang, deal = 'sale' }: { lang: string; deal?: 'sale' | 'rent' }) {
  const isFr = lang === 'fr';
  const rent = deal === 'rent';
  const [isModalOpen, setIsModalOpen] = useState(false);
  // Mounted from the first opening on, so that closing still animates.
  const [wasOpened, setWasOpened] = useState(false);

  return (
    <>
      <div className="w-full bg-champagne rounded-2xl p-4 sm:p-5 shadow-md relative overflow-hidden mt-4 mb-2 cursor-pointer hover:shadow-2xl transition-shadow group" onClick={() => { setWasOpened(true); setIsModalOpen(true); }}>
        <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-center md:text-left flex-1">
            <h2 className="text-xl sm:text-2xl font-display font-extrabold text-black mb-1 tracking-tight">
              {rent ? (isFr ? 'Louez. Simplement. Gratuitement.' : 'Rent it out. Simply. For Free.') : isFr ? 'Vendez. Simplement. Gratuitement.' : 'Sell. Simply. For Free.'}
            </h2>
            <p className="text-sm sm:text-base text-black/80 font-medium">
              {rent
                ? (isFr ? 'Pour les propriétaires et les agences immobilières.' : 'For landlords and real estate agencies.')
                : isFr
                  ? 'Pour les particuliers et les agences immobilières.'
                  : 'For private sellers and real estate agencies.'}
            </p>
          </div>
          
          <div className="shrink-0">
            <button className="flex items-center gap-2 bg-black text-champagne px-6 py-3 rounded-full font-bold text-sm sm:text-base transition-transform group-hover:scale-105 shadow-md">
              <Plus className="w-5 h-5" />
              {rent ? (isFr ? 'Publier une location' : 'Add Your Rental') : isFr ? 'Publier une annonce' : 'Add Your Listing'}
              <ArrowRight className="w-4 h-4 ml-1 opacity-70" />
            </button>
          </div>
        </div>
      </div>

      {/* Into <body>: this promo sits in a section laid out only when it
          scrolls into view (render-later, content-visibility), which would
          otherwise clip the window to the section instead of the screen. */}
      {wasOpened &&
        createPortal(<AddListingPromoModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} lang={lang} deal={deal} />, document.body)}
    </>
  );
}
